import { Observable } from 'rxjs';

import type {
  ExtendedApiResponse,
  BaseApiRequest,
  SourceOfFoundsResponse
} from '@coin-depo-types';

export interface FoundsApi {

    getSourceOfFunds(
        data: BaseApiRequest & { username?: string; client_token?: string }
    ): Observable<ExtendedApiResponse<SourceOfFoundsResponse>>;
}